export enum DataHooks {
  ROOT = 'tag-line-root',
  TEXT = 'tag-line-text',
}
